<template>
  <div id="cards">
    <Card title="Sistemas Empresariales" imagen="far fa-building"
          contenido="La misión de adaptar e integrar los procesos exclusivos de tu empresa." />

    <Card title="Aplicaciones a la Medida" imagen="fas fa-mobile-alt"
          contenido="Para situaciones específicas y particulares construimos conjuntamente la solución que se ajuste por completo a tus necesidades." />

    <Card title="Sitios Web" imagen="fas fa-globe-americas"
          contenido="Creamos sitios web exitosos, con diseños hermosos e inteligentes, de acuerdo a las necesidades de tu empresa." />

    <Card title="Posicionamiento SEO" imagen="fas fa-medal"
          contenido="Tu cliente te va a encontrar sin tener que buscarte." />

    <Card title="Fabrica de Hardware" imagen="fas fa-medal"
          contenido="Arma la pc de tus sueños (Diseño, Programación, PC-entrada, Servidores) a tu gusto y presupuesto" />
  </div>
</template>

<script>
   import Card from "./Card";
   export default {
      name: "CardView",
     components: {Card},
     created: function () {
       window.addEventListener('resize', this.resize);

       setTimeout(this.resize, 300);
     },
     methods: {
        resize: function () {
          const size = window.innerWidth;
          let noItems = Math.floor(window.innerWidth / 320);
          noItems = noItems <= 9 ? noItems : 9;
          let percent = 100 / (noItems > 0 ? noItems : 1);

          let cards = document.getElementById('cards').children.length;

          if (noItems > cards) {
            percent = 100 / (cards > 0 ? cards : 1);
            document.getElementById('cards').style.justifyContent = 'center';
          }
          else {
            document.getElementById('cards').style.justifyContent = '';
          }

          document.documentElement.style.setProperty("--size", 'calc(' + percent + '% - 20px)');
          console.log('calc(' + percent + '% - 20px)')
        }
     }
   }
</script>

<style scoped lang="scss">
  @import "../../style/base";

  #cards {
    @include flexRow;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;

    & .card {
      min-width: 280px;
      max-width: 400px;
      margin: 10px;
      width: var(--size);
    }

    @include responsive_layout('customSmall') {
      justify-content: flex-start;
    }

    @include responsive_layout('customNormal') {
      justify-content: flex-start;
    }

  }

</style>
